import { NgModule } from '@angular/core';
import { UnauthenService } from './unauthen.service';

@NgModule({
    providers: [
        UnauthenService
    ]
})
export class UnauthenServiceModule { }
